const status = [
    { id: 1, value: 'Todos', label: 'Todos' },
    { id: 2, value: 'Pedido realizado', label: 'Pedido realizado' },
    { id: 3, value: 'Em preparação', label: 'Em preparação' },
    { id: 4, value: 'Pedido a caminho', label: 'Pedido a caminho' },
    { id: 5, value: 'Pedido entregue', label: 'Pedido entregue' },
]

export default status